import certificate from '@/api/common/certificate'

const data = {
  items: sessionStorage.getItem('certificates')
    ? JSON.parse(sessionStorage.getItem('certificates'))
    : []
}

export default {
  namespaced: true,
  state () {
    return {
      ...data
    }
  },
  mutations: {
    /**
     * Reset the state to default.
     *
     * @param {*} state
     */
    RESET (state) {
      for (const key in state) {
        state[key] = data[key]
      }
    },

    /**
     * Set the items.
     *
     * @param {*} state
     * @param {*} items
     */
    SET_ITEMS (state, items) {
      state.items = items
    }
  },
  actions: {
    /**
     * Get all CompanySize.
     *
     * @param {*} param
     */
    all ({ commit, dispatch, state }, params) {
      if (state.items.length) return

      return certificate.advancedSearch(params)
        .then(({ data }) => {
          commit('SET_ITEMS', data)

          sessionStorage.setItem('certificates', JSON.stringify(data))
        })
        .catch(({ response }) => dispatch('httpException/handle', response, { root: true }))
    }
  }
}
